module.exports = __webpack_public_path__ + "img/swich_open.52c4e3e7.png";